import { Event } from '@/types/event';
import { PaginatedEventsResult } from './eventsDataShared';
import { UseEventsQueryOptions, useEventsQuery } from './useEventsQuery';
import { usePaginatedQueryResult } from './usePaginatedQueryResult';

export type UsePaginatedEventsOptions = UseEventsQueryOptions;

export function usePaginatedEvents(
    options: UsePaginatedEventsOptions,
): PaginatedEventsResult<Event> {
    return usePaginatedQueryResult<Event>(useEventsQuery(options));
}
